type Props = {
  percent: number;
  color: string;
};

export function ProgressBar({ percent, color }: Props) {
  return (
    <div className="h-2 bg-gray-100 rounded-full overflow-hidden mb-[16px]">
      <div
        className="h-full rounded-full transition-all duration-300"
        style={{ width: `${percent}%`, backgroundColor: color }}
      />
    </div>
  );
}
